import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import ExpressiveSmText from 'shared/components/vxl/typography/expressive/ExpressiveSmText';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import theme from 'shared/styles/theme';

interface SmartViewBalanceProps {
  title: string;
  balanceAmount: string;
  onInfoClick: () => void;
  hasInfoIcon: boolean;
}

const SmartViewBalance = ({
  title,
  balanceAmount,
  onInfoClick,
  hasInfoIcon,
}: SmartViewBalanceProps) => {
  return (
    <>
      <View style={styles.smartViewTitleContainer}>
        <BodySmBoldText data-testId="balanceTitle">{title}</BodySmBoldText>
        {hasInfoIcon ? (
          <Pressable onPress={onInfoClick}>
            <Icon
              iconKey="INFO"
              iconSize="SM"
              iconAccessibilityLabel="infoIcon"
            />
          </Pressable>
        ) : null}
      </View>
      <ExpressiveSmText data-testId="balance">{balanceAmount}</ExpressiveSmText>
    </>
  );
};

const styles = StyleSheet.create({
  smartViewTitleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing.xs,
    justifyContent: 'space-between',
  },
});

export default SmartViewBalance;
